import "./SectionMetaNinjaz.css";

export const SectionMetaNinjaz = () => {
  return (
    <div className="section-meta-ninjaz">
      <h2>Meta Ninjaz</h2>
      <div>
        The MetaNinjaz is a randomly generated collection of 888 MetaNinjaz
        Genesis pieces and 8000 MetaNinjaz roaming the blockchain.
      </div>
      <div>
        Summoned to protect against a crippled Cyber-Tokyo, MetaNinjaz possess
        p2e utility gaining $RUN token in a side scroller game.
      </div>
      <div>
        $RUN will be the staple token for the MetaNinjaz community allowing for
        governance, rewards, and merchandise.
      </div>
      <img src="/fire.gif" />
    </div>
  );
};
